module.exports = __webpack_public_path__ + "img/delivery.d84fb50.webp";